'use client';

import { Container, Paper, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import type { PageWidgetItem } from '../../../types/content';
import {
  getWidgetCardStyle,
  widgetSectionPadding,
  widgetSubtitleStyle,
  widgetTitleStyle,
} from './widgetStyles';

export function TestimonialCardsWidget({
  title,
  subtitle,
  items,
}: {
  title?: string;
  subtitle?: string;
  items: PageWidgetItem[];
}) {
  if (!items.length) return null;

  return (
    <Container size="xl" py={widgetSectionPadding}>
      <Stack gap={14}>
        {title ? <Title order={2} style={widgetTitleStyle}>{title}</Title> : null}
        {subtitle ? <Text style={{ ...widgetSubtitleStyle, maxWidth: 740 }}>{subtitle}</Text> : null}

        <SimpleGrid cols={{ base: 1, md: 2 }} spacing={18}>
          {items.map((item, index) => (
            <Paper
              key={`${item.title || 'testimonial'}-${index}`}
              p={24}
              radius={32}
              withBorder
              style={getWidgetCardStyle(index, { emphasize: index === 1 })}
            >
                <Stack gap={8}>
                  <Text style={{ ...widgetSubtitleStyle, maxWidth: 'unset' }}>
                    &ldquo;{item.body || item.title || ''}&rdquo;
                  </Text>
                {(item.title || item.label) ? (
                  <Text fw={600} style={{ color: 'var(--text-primary)' }}>
                    {item.title || item.label}
                  </Text>
                ) : null}
              </Stack>
            </Paper>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
